export default function getModifiers(modifiers: string[], key: number, activeItemIdx: number): string[] {
  return [...modifiers, key === activeItemIdx ? 'active' : ''].filter(Boolean);
}
